'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 20,
    bottom: 70,
    left: 75,
    right: 10
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    yNumberOfTicks: 10,
    yAxisShift: 12,
    yAxisLabelShift: 55
  };
};
module.exports = Params;